import { render } from "./InfoCardSkeleton.vue?vue&type=template&id=7c8e06a8&scoped=true"
import script from "./InfoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./InfoCardSkeleton.vue?vue&type=script&lang=js"

import "./InfoCardSkeleton.vue?vue&type=style&index=0&id=7c8e06a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8e06a8"]])

export default __exports__